import * as React from 'react';
import styled, { useTheme } from 'styled-components/macro';
import { Modal, PrimaryButton } from 'lib/components';
import { theme } from '../../style';

const TextContainer = styled.div`
  font-family: 'Work Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  width: 100%;
  overflow: auto;
  margin-top: 3%;
  height: 378px;
  color: #333333;
`;

const ButtonsContainer = styled.div`
  text-align: right;
  padding: 0.7em 1em 0.5em 0.4em;
  margin-top: 6px;
`;

const SimpleButtons = styled(PrimaryButton)`
  height: 40px;
  font-size: ${theme.fontSizes.m};
  font-weight: 600;
  border-radius: 5px;
`;

const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
`;

const Title = styled.h2`
  margin-right: auto;
  padding: 0;

  font-weight: 700;
  font-size: 18px;
  color: ${theme.palette.coal};
`;

type Props = {
  disabled?: boolean;
  title?: string;
  text?: any;
  displayModal: boolean;
  handleModalClose: () => void;
  handleSubmit: () => void;
};

export const ModalAffiliateTerms = ({
  text = '',
  handleModalClose,
  handleSubmit,
}: Props) => {
  const themes = useTheme();
  const escPress = (key: string) => {
    if (key === 'Escape') {
      handleModalClose();
    }
  };
  React.useEffect(() => {
    document.addEventListener('keyup', e => escPress(e.key));

    return () =>
      document.removeEventListener('keyup', e => escPress(e.key), true);
  });

  return (
    <Modal widthOnDesktop={'60%'}>
      <Content>
        <Title>Terms and Conditions</Title>
        <TextContainer>{text}</TextContainer>
      </Content>
      <ButtonsContainer>
        <SimpleButtons
          iconPadding={8}
          backgroundColor={theme.palette.primaryDarkGray}
          textColor={theme.palette.white}
          fontWeight={600}
          text={'Cancel'}
          margin='0 0 0 12px'
          width={'100px'}
          onClick={handleModalClose}
        />
        <SimpleButtons
          iconPadding={8}
          backgroundColor={themes.colors.primaryColor}
          textColor={theme.palette.white}
          fontWeight={600}
          text={'I Agree'}
          margin='0 0 0 12px'
          width={'100px'}
          onClick={handleSubmit}
        />
      </ButtonsContainer>
    </Modal>
  );
};
